import Config from "../../config";

function showApplicationGuide() {
    const planName = sessionStorage.getItem("planName"); 
    let url = Config.api + "/DownloadUserReferenceGuide?planName=" + encodeURIComponent(planName);

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "GET",
            headers: {
                Authorization: sessionStorage.getItem("access_token"),
                Accept: "application/pdf"
            }
        })
        .then(res => res.blob())
        .then(res => {
            let blob = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(blob);
            sessionStorage.setItem("ApplicationGuideURL", fileURL);
            resolve(res);
        })
        .catch(err => reject(err));
    });
}

export default showApplicationGuide;